import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from './../../environments/environment';
import { Observable } from 'rxjs/Observable';

import 'rxjs/add/observable/of';
import 'rxjs/add/operator/mapTo';
import { map } from 'rxjs/operators';
import { RoburCertificationRequest, RoburCertificationRequestResult, ContactSalesRequest, ContactSalesRequestResult } from '../models';

@Injectable()
export class BackendService {

    getRandomSeed(): string {
        return (Math.random() * 10000000000).toFixed(0);
    }
    constructor(private http: HttpClient, ) {
        //
    }

    public requestRoburCertificate(request: RoburCertificationRequest):
        Observable<RoburCertificationRequestResult> {

        /*return Observable.of(new Object()).mapTo(RoburCertificationRequestResult.);*/

        // debugger;
        return this.http.post<RoburCertificationRequestResult>(environment.roburCertificationRequestUrl, {
            request: request
        });

    }

    public contactSales(request: ContactSalesRequest):
        Observable<ContactSalesRequestResult> {

        return this.http.post<ContactSalesRequestResult>(environment.contactSalesUrl, {
            request: request
        });

    }


}



// WEBPACK FOOTER //
// ./src/app/services/backend.service.ts